/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { PreloadStrategy as IPreloadStrategy } from "."
 * @import { Content } from "../content/content"
 * @import { ViewerRegistry } from "../viewer/registry"
 */

/**
 * @implements {IPreloadStrategy}
 */
export class DefaultPreloadStrategy {
  /** @type {IPreloadStrategy['canPreload']} */
  canPreload(next, curr, prev) {
    // Ve výchozím případě přednačítáme vždy.
    return true;
  }
}

/**
 * Rozhodne, zda je možné přednačíst video na zařízeních, kde je problém s přehráváním videí.
 * V situaci kdy:
 * - předchozí obsah (`prev`) **není** video,
 * - současný obsah (`current`) **je** video,
 * - následující obsah (`next`) **je** video.
 * přednačtení `next` způsobí artefakty na aktuálně přehrávaném videu. Proto se vrací `false`.
 * Ve všech ostatních případech se vrací `true`.
 * @param {ViewerRegistry} viewerRegistry - Registr prohlížečů médií, slouží k určení typu vieweru pro daný typ média.
 * @param {Content} next - Obsah, který má být přednačten.
 * @param {Content} curr
 * @param {Content} [prev]
 * @returns {boolean} `true` pokud lze přednačíst, `false` pokud by přednačtení
 * způsobilo problémy se zobrazením aktuálního videa.
 */
export function canPreloadVideoOnLimitedDevice(
  viewerRegistry,
  next,
  curr,
  prev
) {
  if (!(prev?.medium && curr?.medium && next?.medium)) {
    return true;
  }

  const prevViewerType = viewerRegistry.find(prev.medium.type);
  const currentViewerType = viewerRegistry.find(curr.medium.type);
  const nextViewerType = viewerRegistry.find(next.medium.type);
  if (!prevViewerType || !currentViewerType || !nextViewerType) {
    return true;
  }

  return !(
    !prevViewerType.getSourceCreator().isUsingVideoElement() &&
    currentViewerType.getSourceCreator().isUsingVideoElement() &&
    nextViewerType.getSourceCreator().isUsingVideoElement()
  );
}
